// library
import * as React from "react";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";

// internal
import { styles } from "./CalendarHours.styles";

export interface CalendarHoursProps extends WithStyles<typeof styles> {
  showBorder: boolean;
  showEveryN: number;
  minSlotOffset: number;
  maxSlotOffset: number;
  hourTextStyle?: React.CSSProperties;
  hourTextContainerStyle?: React.CSSProperties;
  showShortHours?: boolean;
}

export interface CalendarHoursState {}

class CalendarHoursComponent extends React.Component<CalendarHoursProps, CalendarHoursState> {
  static defaultProps = {
    showBorder: true,
    showEveryN: 2,
    minSlotOffset: 0,
    maxSlotOffset: 48,
  };

  public render() {
    const {
      showEveryN,
      minSlotOffset,
      maxSlotOffset,
      showBorder,
      hourTextStyle,
      showShortHours,
      hourTextContainerStyle,
    } = this.props;

    const hoursText = new Array(49).fill(null).map((_n, j) => {
      const i = Math.floor(j / 2);
      const mins = j % 2 !== 0 ? "30" : "00";
      return `${i % 12 ? i % 12 : 12}${showShortHours ? "" : `:${mins}`}${
        i >= 12 && i < 24 ? "pm" : "am"
      }`;
    });

    return (
      <div
        className={this.props.classes.textContainer}
        style={{ borderRight: showBorder ? undefined : "none", ...hourTextContainerStyle }}
      >
        {hoursText.map((hourText, j) => {
          if (j < minSlotOffset || j > maxSlotOffset || j % showEveryN !== 0) {
            return null;
          }

          const i = j - minSlotOffset;

          const top = `${(100 * i) / (maxSlotOffset - minSlotOffset)}%`;

          return (
            <div key={i} className={this.props.classes.text} style={{ top, ...hourTextStyle }}>
              {hourText}
            </div>
          );
        })}
      </div>
    );
  }
}

export const CalendarHours = withStyles(styles)(CalendarHoursComponent);
